import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../lib/site";
import usePageMeta from "../hooks/usePageMeta";

export default function FAQ() {
  usePageMeta({title:"FAQ - Erotic Hypnosis Answered",description:"Frequently asked questions about erotic hypnosis with Queen Cleopatra: safety, consent, recording, preparation, refunds and privacy.",path:"/faq"});
  return (
    <div data-testid="page-faq">
      <section className="py-24 md:py-32 max-w-4xl mx-auto px-6 md:px-10">
        <div className="eyebrow mb-5">Questions</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cream leading-[1]">
          Frequently <em className="text-gold">considered</em>.
        </h1>
        <p className="mt-6 text-cream/70 leading-relaxed">
          Safety, recording, preparation, refunds, privacy. If your question is missing,
          please do <a href="/contact" className="link-gold">write to me</a>.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 pb-32">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#c9a04b]/15">
              <AccordionTrigger
                data-testid={`faq-q-${i}`}
                className="font-serif text-xl md:text-2xl text-cream py-6 hover:text-gold hover:no-underline text-left"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-cream/70 leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
